/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux-immutable';

import globalReducer from './containers/App/reducer';
import authReducer from './containers/Authentication/Auth/reducer';
import customerDashboardReducer, { benchmarkConfigurationReducer } from './containers/CustomerDashboard/reducer';
import {
  guideTourReducer,
  sideMenuReducer,
  analyseDropdownReducer
} from './components/Header/reducer';
import {reportingReducer} from "./containers/GroupReporting/reducer";
import {assetModalReducer} from "./components/AssetModal/reducer";
import {createGroupReducer} from "./containers/ReportGroupCreation/reducers";
import {reportSettingsReducer} from "./containers/DashboardSettings/reducers";
import customersDataReducer from './components/CustomersDataProvider/reducer';
import sharedSettingsReducer from './components/SharedSettingsProvider/reducer';
import investmentPlatformReducer from './containers/InvestmentPlatform/reducer';
import snackbarReducer from './components/SnackbarProvider/reducer';
import themeReducer from './components/CustomerThemeProvider/reducer';
import {guideTourSettingsReducer} from "./components/GuideTour/reducer";
import onboardingReducer from './containers/RiskProfiling/reducer';
import productsComparisonDataReducer from './containers/ProductComparison/reducer';
import combinedTradingReducer from './components/TradingStore/reducer'

/**
 * Creates the main reducer with the dynamically injected ones
 */
export default function createReducer(injectedReducers) {
  return combineReducers({
    global: globalReducer,
    auth: authReducer,
    customerDashboard: customerDashboardReducer,
    guide: guideTourReducer,
    sideMenu: sideMenuReducer,
    analyseDropdown: analyseDropdownReducer,
    reporting: reportingReducer,
    benchmarkConfiguration: benchmarkConfigurationReducer,
    assetModal: assetModalReducer,
    createGroup: createGroupReducer,
    reportSettings: reportSettingsReducer,
    sharedSettings: sharedSettingsReducer,
    guideTourSettings: guideTourSettingsReducer,
    customersDataProvider: customersDataReducer,
    customerThemeProvider: themeReducer,
    investmentPlatform: investmentPlatformReducer,
    snackbar: snackbarReducer,
    onboarding: onboardingReducer,
    combinedTrading: combinedTradingReducer,
    productsComparison: productsComparisonDataReducer,
    ...injectedReducers,
  });
}
